export const RECEIVE_SHOW_EPISODES = 'create/shows/RECEIVE_SHOW_EPISODES';
export const RECEIVE_SHOW_DRAFTS = 'create/show/RECEIVE_SHOW_DRAFTS';
export const ADD_DRAFT = 'create/draft/ADD';
export const ADD_SHOW_DRAFT = 'create/show/ADD_DRAFT';
